module.exports = __webpack_public_path__ + "img/features-product-mob.5b4bf5d.webp";